import * as React from 'react';

import { CartServiceProps } from '../../types';
import { ServiceSummary } from '../../../features/service-summary';

const Sms: React.FC<CartServiceProps> = ({ onServiceDelete }) => {
	return (
		<ServiceSummary serviceType="Sms" onDelete={onServiceDelete}>
			{content => <>{content}</>}
		</ServiceSummary>
	);
};

export default Sms;
